
export enum TrailerAgendaItemActionCd {
	CITY_ARRIVE = 'CityArrive',
	CLOSE_FOR_DELIVERY = 'CloseForDelivery',
	LINEHAUL_ARRIVE = 'LinehaulArrive',
	LINEHAUL_CLOSE = 'LinehaulClose',
	LINEHAUL_DISPATCH = 'LinehaulDispatch',
	LINEHAUL_LOADING_AT_DOCK = 'LinehaulLoadingAtDock'}

